import i18next from 'i18next';

import EntityFactory from '../factory/famly-app';
import Child from './model';
import reducerExtension from './reducer-extension';
import {GROUP_BY_KEYS} from './constants';

export default EntityFactory.createEntity({
    domain: 'ENTITIES/CHILDREN',
    entityName: i18next.t('entities.names.child'),
    model: Child,
    groupByKeys: GROUP_BY_KEYS,
    reducerExtension,
    apiDescription: {
        fetchAll: {
            url: 'v2/children/',
            requestPayload: payload =>
                payload.groupIds
                    ? // With alwaysShowPickup param the API always sends pickupTime
                      {future: payload.future, groupIds: payload.groupIds, alwaysShowPickup: true}
                    : {future: payload.future, tagIds: [payload.tagId], alwaysShowPickup: true},
        },
    },
});
